var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 88,
    viewBox: "0 0 335 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11449_46873",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 88
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 88,
    rx: 12,
    fill: "#CFC8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 334,
    height: 87,
    rx: 11.5,
    stroke: "url(#paint0_linear_11449_46873)",
    strokeOpacity: 0.2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11449_46873)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.842 -0.435503L302.44 16.5814",
    stroke: "#42ADA7",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.475 49.627L286.187 73.9369",
    stroke: "#42ADA7",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.068 14.1481L282.482 46.3752L294.794 93.1668C296.057 97.9677 291.184 102.085 286.661 100.038L212.55 66.4954C208.027 64.4485 207.904 58.0697 212.345 55.8505L255.626 34.2202L270.212 1.9931",
    stroke: "#42ADA7",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 297.775,
    cy: -1.70829,
    rx: 2.94785,
    ry: 2.94785,
    transform: "rotate(24.3515 297.775 -1.70829)",
    fill: "#42ADA7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.132,
    cy: -5.10017,
    rx: 5.89571,
    ry: 5.8957,
    transform: "rotate(24.3515 283.132 -5.10017)",
    fill: "#42ADA7"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: -22,
    r: 114,
    fill: "#A18AF5",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: -22,
    r: 101.9,
    stroke: "url(#paint1_linear_11449_46873)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9 -22C73.9 28.755 32.755 69.9 -18 69.9C-68.755 69.9 -109.9 28.755 -109.9 -22C-109.9 -72.755 -68.755 -113.9 -18 -113.9C32.755 -113.9 73.9 -72.755 73.9 -22Z",
    fill: "#A18AF5",
    fillOpacity: 0.05,
    stroke: "url(#paint2_linear_11449_46873)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9 -22C63.9 23.2321 27.2321 59.9 -18 59.9C-63.2321 59.9 -99.9 23.2321 -99.9 -22C-99.9 -67.2321 -63.2321 -103.9 -18 -103.9C27.2321 -103.9 63.9 -67.2321 63.9 -22Z",
    fill: "#A18AF5",
    fillOpacity: 0.05,
    stroke: "url(#paint3_linear_11449_46873)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9 -22C52.9 17.157 21.157 48.9 -18 48.9C-57.157 48.9 -88.9 17.157 -88.9 -22C-88.9 -61.157 -57.157 -92.9 -18 -92.9C21.157 -92.9 52.9 -61.157 52.9 -22Z",
    fill: "#A18AF5",
    fillOpacity: 0.05,
    stroke: "url(#paint4_linear_11449_46873)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9 -22C42.9 11.6341 15.6341 38.9 -18 38.9C-51.6341 38.9 -78.9 11.6341 -78.9 -22C-78.9 -55.6341 -51.6341 -82.9 -18 -82.9C15.6341 -82.9 42.9 -55.6341 42.9 -22Z",
    fill: "#A18AF5",
    fillOpacity: 0.05,
    stroke: "url(#paint5_linear_11449_46873)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9 -22C32.9 6.11129 10.1113 28.9 -18 28.9C-46.1113 28.9 -68.9 6.11129 -68.9 -22C-68.9 -50.1113 -46.1113 -72.9 -18 -72.9C10.1113 -72.9 32.9 -50.1113 32.9 -22Z",
    fill: "#A18AF5",
    fillOpacity: 0.05,
    stroke: "url(#paint6_linear_11449_46873)",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11449_46873",
    x1: -4.7111e-7,
    y1: 2.2,
    x2: 198.737,
    y2: 215.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7EDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11449_46873",
    x1: 71.5,
    y1: 38,
    x2: -70,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5133D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11449_46873",
    x1: 62.7255,
    y1: 32.1176,
    x2: -64.902,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5133D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11449_46873",
    x1: 53.951,
    y1: 26.2353,
    x2: -59.8039,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5133D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11449_46873",
    x1: 44.299,
    y1: 19.7647,
    x2: -54.1961,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5133D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11449_46873",
    x1: 35.5245,
    y1: 13.8823,
    x2: -49.098,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5133D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11449_46873",
    x1: 26.75,
    y1: 7.99999,
    x2: -44,
    y2: -22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5133D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabBackground);
export default __webpack_public_path__ + "static/media/LabBackground.c4a67b6be4ec5565bc04c87f538d9ae0.svg";
export { ForwardRef as ReactComponent };